// i18n/index.ts

import { createI18n } from "vue-i18n";
import zh from "@/i18n/langs/zh";
import en from "@/i18n/langs/en";

let defaultLang = "zh";
var commoninfo = JSON.parse(localStorage.getItem("commoninfo"));
if (commoninfo && commoninfo.language) {
  defaultLang = commoninfo.language || "zh";
}

const messages = {
    zh,
    en,
  };

let i18n = new createI18n({
  messages,
  legacy: false,
  locale: defaultLang,
});


export default i18n;

